<template>
  <div
    class="amapDemo"
    :style="{ height: windowHeight + 'px', width: windowWidth + 'px' }"
    @contextmenu="cale();"
  >
    <el-amap-search-box
      class="search-box"
      :search-option="searchOption"
      :on-search-result="onSearchResult"
    >
    </el-amap-search-box>
    <el-amap
      class="amap-box"
      vid="make_map"
      ref="make_map"
      :zooms="zooms"
      :center="center"
      :zoom="zoom"
      :events="events"
      :amap-manager="amapManager"
      :plugin="plugin"
    >
      <el-amap-text
        v-for="xx of poi"
        :key="xx.Bounds_id"
        :draggable="true"
        :position="xx.location.coordinates"
        :text="xx.name"
        :events="markerevent"
      >
      </el-amap-text>
      
        <el-amap-polyline
          v-for="(xx) of poiss"
          :key="xx.id"
          :vid="xx.id"
          :path="xx.boundary"
          borderWeight= 2
          strokeColor= 'red'
        >

        </el-amap-polyline>
     
      <el-amap-polyline :path="district" borderWeight="2" strokeColor="red">
      </el-amap-polyline>
      <el-amap-polyline :path="cityDistrict" borderWeight="2" strokeColor="red">
      </el-amap-polyline>
      <el-amap-rectangle
        v-for="item of bounds"
        :bounds="item.bounds"
        :key="item._id"
        :fillOpacity="0.5"
        :fillColor="item.status == '1' ? 'glay' : 'blue'"
        :strokeWeight="1"
        stroke-color="#000"
        :events="recevent"
        :vid="item._id"
      ></el-amap-rectangle>
      <el-amap-rectangle
        v-for="(item, index) of bounds_copy"
        :bounds="item"
        :key="JSON.stringify(item) + index"
        :fillOpacity="0.5"
        :fillColor="'blue'"
        :strokeWeight="1"
        stroke-color="#000"
        :events="recevent"
        :vid="JSON.stringify(item) + index"
      ></el-amap-rectangle>
      <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
        <span
          >名字：<input type="text" v-model="poideletetarget.name"><br />
          类型：{{
            poideletetarget.owntype
              ? poideletetarget.owntype
              : poideletetarget.typecode
          }}</span
        >
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false;">取 消</el-button>
          <el-button type="primary" @click="deleteOne();">删除一个</el-button>
          <el-button type="primary" @click="setPopxy('deleteKind');"
            >删除一类</el-button
          >
          <el-button type="primary" @click="cancelOne();">取消一个</el-button>
          <el-button type="primary" @click="setPopxy('cancelKind');"
            >取消一类</el-button
          >
          <el-button type="primary" @click="changeKind();"
            >删除此范围</el-button
          >
          <el-button type="primary" v-if="!ifDraggWrite" @click="startChangeCenterPoint"
            >开始更换中心点</el-button
          >
          <el-button type="primary" v-if="ifDraggWrite" @click="changeCenterPoint"
            >更换中心点</el-button
          >
          <el-button type="primary"  @click="changeName"
            >更改名字</el-button
          >
        </span>
      </el-dialog>
      <el-dialog title="提示" :visible.sync="ifShowSpace" width="30%">
        <el-button @click="ifShowSpace = false;">取 消</el-button>
        <el-button @click="setFinishedMOde();">设置完成状态</el-button>
        <el-button @click="cancelFinishedMOde();">取消完成状态</el-button>
      </el-dialog>
      <el-dialog title="提示" :visible.sync="ifsetServer" width="30%">
        <div>
          名字:{{ information.name }}<br />
          类型：{{ information.type }}
        </div>
        <div><input type="text" v-model="information.name" /></div>
        <div><input type="text" v-model="information.owntype" /></div>
        <el-button @click="ifsetServer = false;">取 消</el-button>
        <el-button @click="setInformation();">上传</el-button>
      </el-dialog>
      <el-dialog title="提示" :visible.sync="ifdeletekind" width="30%">
        <el-button @click="ifdeletekind = false;">取 消</el-button>
        <el-button type="primary" @click="ifdelete();">确定</el-button>
      </el-dialog>
      <div id="editor">
        <div>
          <input
            v-model="amapName"
            type="text"
            placeholder="请输入城市名字,回车搜索"
            @keyup.enter="searchCity"
          />
          <el-select
            v-model="districtSelect"
            multiple
            placeholder="请选择"
            @change="changedistrictList();"
          >
            <el-option
              v-for="item in districtList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div>需要展示的数据：{{ lookdatanumber }}</div>
        <div>需要多少个数据展示范围：{{ lookboundarynumber }}</div>
        <el-button @click="setPolygon();">上传</el-button>
        <!-- <el-button @click="getnum();">上</el-button> -->
      </div>
      <div id="boundaryEditor">
        <div>
          获取城市范围格子：
          <input
            v-model="amapCenterName"
            type="text"
            placeholder="请输入城市名字"
          />
          <el-button @click="getBoundary();">获取所有范围格子</el-button>
        </div>
        <div>
          获取城市区域线内格子：
          <input
            type="text"
            v-model="cityName"
            placeholder="请输入城市名字,回车搜索"
            @keydown.enter="getArea();"
          />
          <el-select
            v-model="searchDistrictSelect"
            placeholder="请选择"
            @change="getLine();"
          >
            <el-option
              v-for="item in searchDistrictList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button @click="setLine();">上传</el-button>
        </div>
      </div>
    </el-amap>
  </div>
</template>
<script>
import { AMapManager } from "vue-amap";
let amapManager = new AMapManager();
// import filejson from "./filejson4.json";
export default {
  data() {
    return {
      amapName:'',
      disPolygon: null,
      cityName: "",
      searchDistrictSelect: "",
      searchDistrictList: [],
      cityDistrict: [],
      amapCenterName: "",
      bounds_copy: [],
      bounds_copy_copy:[],
      districtList: [
      ],
      districtSelect: "",
      district: [],
      plugin: [
        {
          //地图类型，卫星地图和普通地图
          pName: "MapType",
          defaultType: 0
        }
      ],
      ifxyxy: false,
      poiss:[],
      codecopy: 0,
      poisscopy:[],
      lookdatanumber: 0,
      lookboundarynumber: 0,
      boundaryindex: 0,
      ifpolygon: 0,
      pathmarker: [],
      ind: 0,
      path: [],
      polygon: {},
      searchOption: {
        city: "上海",
        citylimit: true
      },
      popxy: "",
      ifdeletekind: false,
      oneText: [],
      information: {},
      ifsetServer: false,
      setServer: "",
      id: 0,
      ifShowSpace: false,
      allText: [],
      showText: [],
      bound: [],
      bounds: [],
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
      poi: [],
      code: null,
      amapManager,
      zooms: [5, 18], // 地图缩放级别
      zoom: 15, // 地图缩放级别
      center: [121.47, 31.23],
      ifDraggWrite:false,
      events: {
        //地图建立完成后的生命周期函数
        complete: e => {
          let currentMap = amapManager.getMap();
          // this.drawDistrict(currentMap);
        },
        // 地图事件
        zoomchange: e => {
          let currentMap = amapManager.getMap();
          let zoom = currentMap.getZoom();
          if (zoom < 14) {
            this.deleteText(currentMap);
          } else {
            this.drwaText(currentMap);
          }
        }
      },
      markereven: {
        click: e => {
          let id = e.target.w.vid * 1;
          let currentMap = amapManager.getMap();
          let one = [e.target.De.position.lng, e.target.De.position.lat];
          let marker = this.pathmarker[id];
          currentMap.remove(marker);
          for (var item = 0; item < this.path.length; item++) {
            if (this.path[item].lng) {
              if (this.path[item].lng == one[0]) {
                this.path.splice(item, 1);
              }
            } else {
              if (this.path[item][0] == one[0]) {
                this.path.splice(item, 1);
              }
            }
            this.polygon.setOptions({
              path: this.setboundary()
            });
          }
        },
        dragstart: e => {
          let currentMap = amapManager.getMap();
          let one = [e.target.De.position.lng, e.target.De.position.lat];
          for (var item = 0; item < this.path.length; item++) {
            if (this.path[item].lng) {
              if (this.path[item].lng == one[0]) {
                this.boundaryindex = item;
              }
            } else {
              if (this.path[item][0] == one[0]) {
                this.boundaryindex = item;
              }
            }
          }
        },
        dragging: e => {
          console.log("665656");
          let one = [e.target.De.position.lng, e.target.De.position.lat];
          this.path[this.boundaryindex] = one;
          this.polygon.setOptions({
            path: this.setboundary()
          });
        }
      },
      recevent: {
        click: e => {
          if (this.ifxyxy) {
            let currentMap = amapManager.getMap();
            let pathone = e.lnglat;
            this.path.push(pathone);
            let marker = new AMap.Marker({
              draggable: true,
              vid: "" + this.ind++,
              position: pathone
            });
            marker.on("rightclick", this.markereven.click);
            marker.on("dragstart", this.markereven.dragstart);
            marker.on("dragging", this.markereven.dragging);
            this.pathmarker.push(marker);
            currentMap.add(marker);
            this.startEditor();
          }
        },
        rightclick: e => {
          console.log(e);
          let param = {
            name: "测试",
            cityname: "上海市",
            typecode: "",
            type: "",
            id: this.uuid(),
            location: [e.lnglat.lng, e.lnglat.lat],
            owntype: ""
          };
          this.information = param;
          let pathone = e.lnglat;
          this.ifsetServer = true;
          let currentMap = this.amapManager.getMap();
          currentMap.remove(this.oneText);
          let text1 = new AMap.Text({
            // 文本
            position: pathone,
            text: this.information.name + this.information.owntype
          });
          text1.on("click", this.markerevent1.click);
          text1.on("init", this.markerevent1.init);
          this.oneText.push(text1);
          text1.setMap(currentMap);
        }
      },
      recevents: {
        click: e => {
          let currentMap = this.amapManager.getMap();
          currentMap.remove(this.oneText);
          currentMap.remove(this.polygon);
          currentMap.remove(this.pathmarker);
          let id = e.target.w.vid;
          let bound = [];
          for (var item of this.bounds) {
            if (item.Bounds_id == id) {
              bound = item;
              break;
            }
          }
          this.id = id;
          let botton_left = bound.bounds[0];
          let top_right = bound.bounds[1];
          let center = [e.target.De.position.lng, e.target.De.position.lat];
          this.center = center;
          let poiCopy = [];
          let poi = [];
          this.poi = [];
          let poiss = [];
          this.poiss = [];
          let poisscopy = [];
          this.poisscopy = [];
          let param = {
            longitude: center[0],
            latitude: center[1],
            botton_left: botton_left,
            top_right: top_right
          };
          this.$axios
            .post(this.$url_prefix + "geo/list", param)
            .then(res => {
              poi = res.data.data;
              console.log(res,'res');
              for (var item of poi) {
                if (item.boundary && item.boundary.length != 0) {
                  poiss.push(item)
                  poisscopy.push(item)
                }
              }
              if (poi.length == 0) {
                this.$message("该格子暂无数据");
              }
              this.poi = poi;
               this.poiss = poiss
               console.log(poiss)
               this.poisscopy = poisscopy
            })
            .catch(ggg => {});
        },
        rightclick: e => {
          let id = e.target.w.vid;
          this.id = id;
          this.ifShowSpace = true;
          return false;
        }
      },
      markerevent: {
        init: o => {
          let two = [];
          let poi = this.poi;
          for (var item of poi) {
            two.push(item.name);
          }
          let data1 = o.getText();
          let data = "";
          let length = data1.length;
          let code = two.indexOf(data1.slice(0, length));
          while (code == -1) {
            length = length - 1;
            code = two.indexOf(data1.slice(0, length));
          }
          let poitarget = poi[code];
          if (poitarget.status == 2) {
            o.De.zIndex = 0;
            o.setStyle({
              color: "#fff00",
              "text-decoration": "line-through",
              "font-size": "12px"
            });
          }
          if (poitarget.state && poitarget.state == 1) {
            o.setStyle({
              "background-color": "red"
            });
          } else if (poitarget.state && poitarget.state == 2) {
            o.setStyle({
              "background-color": "#00DDDD"
            });
          } else {
            o.setStyle({
              "background-color": "#FFFF00"
            });
          }
        },
        click: e => {
          let two = [];
          let poi = this.poi;
          let three = [];
          let poiss = [];
          for (var item of poi) {
            two.push(item.name);
          }
          for (var item of this.poisscopy) {
            three.push(item.name);
          }
          let length = e.target.De.text.length;
          let code = two.indexOf(e.target.De.text.slice(0, length));
          let codecopy = three.indexOf(e.target.De.text.slice(0, length));
          while (code == -1) {
            length = length - 1;
            code = two.indexOf(e.target.De.text.slice(0, length));
          }
          this.code = code;
          let poitarget = poi[code];
          if (poitarget.boundary) {
            codecopy = three.indexOf(e.target.De.text.slice(0, length));
            this.codecopy = codecopy;
            for(var i=0;i<this.poisscopy.length;i++){
              if(i==codecopy){continue}
              poiss.push(this.poisscopy[i])
            }
            this.poiss = []
            this.$nextTick(()=>{
            this.poiss = poiss
            })
          }
          this.poideletetarget = poitarget;
          this.dialogVisible = true;
        },
        rightclick: e => {
          this.ifxyxy = true;
          this.ifpolygon = 0;
          let polygon = this.polygon
          let currentMap = this.amapManager.getMap();
          currentMap.remove(this.polygon);
          this.path = [];
          currentMap.remove(this.pathmarker);
          let two = [];
          let three = [];
          let poi = this.poi;
          let poiss = [];
          for (var item = 0; item < poi.length; item++) {
            two.push(poi[item].name);
            poi[item].state = 0;
            if (poi[item].boundary && poi[item].boundary.length != 0) {
              poi[item].state = 2;
            }
          }
          for (var item of this.poisscopy) {
            three.push(item.name);
          }
          let length = e.target.De.text.length;
          let code = two.indexOf(e.target.De.text.slice(0, length));
          let codecopy = three.indexOf(e.target.De.text.slice(0, length));
          while (code == -1) {
            length = length - 1;
            code = two.indexOf(e.target.De.text.slice(0, length));
          }
          this.code = code;
          let poitarget = poi[code];
          console.log(poitarget,'xxxxxxxx');
          poi[code].state = 1;
          this.poi = [];
          this.$nextTick(() => {
            this.poi = poi;
          });
          this.poideletetarget = poitarget;
          if (poitarget.boundary) {
            codecopy = three.indexOf(e.target.De.text.slice(0, length));
            this.codecopy = codecopy;
            for(var i=0;i<this.poisscopy.length;i++){
              if(i==codecopy){continue}
              poiss.push(this.poisscopy[i])
            }
            this.poiss = []
            this.$nextTick(()=>{
            this.poiss = poiss
            })
            this.path = poitarget.boundary;
            for (var item of poitarget.boundary) {
              let marker = new AMap.Marker({
                draggable: true,
                vid: "" + this.ind++,
                position: item
              });
              marker.on("rightclick", this.markereven.click);
              marker.on("dragstart", this.markereven.dragstart);
              marker.on("dragging", this.markereven.dragging);
              this.pathmarker.push(marker);
              currentMap.add(marker);
            }
          }
          this.startEditor();
        },
        dragend:e=>{
          if(this.ifDraggWrite){
              this.poideletetarget.location.coordinates = [e.lnglat.lng,e.lnglat.lat]
              console.log(e,this.poideletetarget,'e')
          }
        }
      },
      markerevent1: {
        click: e => {
          let currentMap = this.amapManager.getMap();
          currentMap.remove(this.oneText);
          let two = [];
          // this.poi.push(this.information)
          let poi = this.poi;
          for (var item of poi) {
            two.push(item.name);
          }

          if (two.indexOf(this.information.name) == -1) {
            poi.push(this.information);
            two.push(this.information.name);
            this.poi = poi;
          }
          let length = e.target.De.text.length;
          let code = two.indexOf(e.target.De.text.slice(0, length));
          while (code == -1) {
            length = length - 1;
            code = two.indexOf(e.target.De.text.slice(0, length));
          }
          this.code = code;
          let poitarget = poi[code];
          this.poideletetarget = poitarget;
          this.dialogVisible = true;
        }
      },
      dialogVisible: false,
      poideletetarget: {}
    };
  },
  mounted() {
    // this.setdist()
    // console.log(this.center,'dis')
    //   let x = this.center[0] + 0.0675 * 0.1;
    //   let y = this.center[1] + 0.0575 * 0.1;
    //   let xy = [x, y];
    //   let x1 = this.center[0] - 0.0675 * 0.1;
    //   let y1 = this.center[1] - 0.0575 * 0.1;
    //   let xy1 = [x1, y1];
    //   let xxyy = [xy, xy1];
    //   console.log(distance,'dis')
    //   let bound = xxyy;
    //   let boundss = [];
    //   for (var i = -20; i < 80; i++) {
    //       let x = bound[0][0];
    //       let y = bound[0][1] + 0.115 * 0.1 * i;
    //       let xy = [x, y];
    //       let x1 = bound[1][0];
    //       let y1 = bound[1][1] - 0.115 * 0.1 * i;
    //       let xxyy = [x1, y1];
    //       for (var j = -50; j < 50; j++) {
    //         let x = bound[0][0] + 0.135 * 0.1 * j;
    //         let y = bound[0][1] + 0.115 * 0.1 * i;
    //         let xy = [x, y];
    //         let x1 = bound[1][0] + 0.135 * 0.1 *j;
    //         let y1 = bound[1][1] + 0.115 * 0.1 * i;
    //         let xxyy = [x1, y1];
    //         let cbdsjdf = [xy, xxyy]
    //         let center = [(cbdsjdf[0][0]-0.135 * 0.05),(cbdsjdf[0][1]-0.115 * 0.05)]
    //         // console.log(center,filejson[0].districts)
    // for(var item of filejson){
    //   let xxxx = AMap.GeometryUtil.isPointInRing(center,item.districts)
    //         // console.log(xxxx)
    //         if(xxxx){
    //           boundss.push({
    //         id:this.uuid(),
    //         status:1,
    //         bounds:[xy, xxyy]
    //       });
    //         }
    // }
    //       }
    // }
    // console.log(boundss)
    // this.bounds = boundss
    // let param = {
    //   bounds: boundss, //各区区域的范围
    //   quyu: filejson
    // };
    // {
    //     params:{
    //       city:'上海'
    //     }
    //   }
    // this.$axios.get(this.$url_prefix + "geo/getBounds",{
    //   params:{
    //     city:'上海'
    //   }
    // }).then(res => {
    //   console.log(res);
    //   this.bounds = res.data.rectangleList;
    // });
    
    document.oncontextmenu = function(event) {
      event.preventDefault();
    };
  },
  beforeDestroy() {
    document.oncontextmenu = function(event) {};
  },
  methods: {
    changeName(){
       this.dialogVisible = false
      this.$axios
        .post(this.$url_prefix + "geo/change/changeName", {
          params: {
            id: this.poideletetarget.id,
            name:this.poideletetarget.name
          }
        })
        .then(res => {
          this.$message({
            type: "success",
            message: "已经成功上传"
          });
        })
        .catch(res => {
          this.$message.error("上传失败");
        });
      console.log(this.poideletetarget)
    },
    startChangeCenterPoint(){
      this.ifDraggWrite = true
      this.dialogVisible = false
    },
    changeCenterPoint(){
      this.ifDraggWrite = false
      this.dialogVisible = false
      this.$axios
        .post(this.$url_prefix + "geo/change/pointCenter", {
          params: {
            id: this.poideletetarget.id,
            location:this.poideletetarget.location
          }
        })
        .then(res => {
          this.$message({
            type: "success",
            message: "已经成功上传"
          });
        })
        .catch(res => {
          this.$message.error("上传失败");
        });
      console.log(this.poideletetarget)
    },
    getnumber() {
      let that = this
      this.$axios
        .get(this.$url_prefix + "geo/get/number", {
          params: {
            status: 1,
            city:that.amapName
          }
        })
        .then(res => {
          this.lookdatanumber = res.data.number2;
          this.lookboundarynumber = res.data.number1;
          console.log('num')
        })
        .catch(e => {
          console.log(e);
        });
    },
    getnum() {
      this.setdist();
    },
    deleteOne() {
      let currentMap = this.amapManager.getMap();
      currentMap.remove(this.oneText);
      let target = this.poideletetarget;
      let idone = target.id;
      let code = this.code;
      let poi = this.poi;
      poi[code].status = 2;
      this.poi = [];
      this.poiss = [];
      let poiss = [];
      for(var i=0;i<this.poisscopy.length;i++){
              if(i==this.codecopy){continue}
              poiss.push(this.poisscopy[i])
            }
      this.$nextTick(() => {
        this.poi = poi;
        this.poiss = poiss;
      });
      this.$axios
        .get(this.$url_prefix + "geo/delete/one", {
          params: {
            id: idone
          }
        })
        .then(res => {
          if (res.data.success) {
            this.dialogVisible = false;
          }
        });
    },
    deleteKind() {
      let currentMap = this.amapManager.getMap();
      currentMap.remove(this.oneText);
      let target = this.poideletetarget;
      let typecode = target.typecode;
      let poi = this.poi;
      for (var i = 0; i < poi.length; i++) {
        if (poi[i].typecode == typecode) {
          poi[i].status = 2;
        }
      }
      this.poi = [];
      this.$nextTick(() => {
        this.poi = poi;
      });
      this.$axios
        .get(this.$url_prefix + "geo/delete/type", {
          params: {
            typecode: typecode
          }
        })
        .then(res => {
          if (res.data.success) {
          }
        });
    },
    cancelOne() {
      let currentMap = this.amapManager.getMap();
      currentMap.remove(this.oneText);
      let target = this.poideletetarget;
      console.log(target);
      let idone = target.id;
      let code = this.code;
      let poi = this.poi;
      poi[code].status = 1;
      this.poi = [];
      // let x = 0;
      // // let poiss = this.poiss;
      // // this.poiss = [];
      // for(var item of poiss){
      //   if(item.id == target.id ){
      //     x = 1
      //   }
      // }
      //     console.log(poiss,this.codecopy,11)
      // if(x==0)poiss.push(this.poisscopy[this.codecopy])
      this.$nextTick(() => {
        this.poi = poi;
        // this.poiss = poiss
      });
      this.$axios
        .get(this.$url_prefix + "geo/cancel/one", {
          params: {
            id: idone
          }
        })
        .then(res => {
          if (res.data.success) {
            this.dialogVisible = false;
          }
        });
    },
    cancelKind() {
      let currentMap = this.amapManager.getMap();
      currentMap.remove(this.oneText);
      let target = this.poideletetarget;
      let typecode = target.typecode;
      let poi = this.poi;
      for (var i = 0; i < poi.length; i++) {
        if (poi[i].typecode == typecode) {
          poi[i].status = 1;
        }
      }
      this.poi = [];
      this.$nextTick(() => {
        this.poi = poi;
      });
      this.$axios
        .get(this.$url_prefix + "geo/cancel/type", {
          params: {
            typecode: typecode
          }
        })
        .then(res => {
          if (res.data.success) {
          }
        });
    },
    // drawDistrict: async function (currentMap) {
    //     let that = this;
    //     let recevents = that.recevents
    //     let areaList = await that.getAreas('区域');
    //     for (let i = 0; i < areaList.length; i++) {
    //       let one = areaList[i];
    //       let dots = one.dots.split('-').map(x => {
    //         return x.split('|')
    //       })
    //       let polygon1 = new AMap.Polygon({ // 范围线
    //         zIndex: -1,
    //         map: currentMap,
    //         strokeWeight: 5,
    //         path: dots,
    //         fillOpacity: 0,
    //         strokeColor: '#383838',
    //         strokeOpacity: 1,
    //       })
    //     }
    // },
    // getAreas: async function (level) { // 拿区域或者板块
    //     let that = this;
    //     return new Promise((resolve, reject) => {
    //       that.$axios.get(that.$url_prefix + 'queryAreaByLevel', {
    //         params: {
    //           level: level,
    //           projection: '-_id id area_name district dots old_price new_price center hot sum_data'
    //         }
    //       }).then(function (res) {
    //         resolve(res.data.data);
    //       }).catch((err) => {
    //         reject(err);
    //       })
    //     })
    //  },
    drwaText(currentMap) {
      currentMap.remove(this.allText);
      let events = this.recevents;
      let allText = [];
      let screenCoordinateRange = currentMap.getBounds();
      let southWest = [
        screenCoordinateRange.southwest.lng,
        screenCoordinateRange.southwest.lat
      ];
      let northEast = [
        screenCoordinateRange.northeast.lng,
        screenCoordinateRange.northeast.lat
      ];
      for (var item of this.bounds) {
        let center = [
          (item.bounds[0][0]+item.bounds[1][0])/2,
          (item.bounds[0][1]+item.bounds[1][1])/2
        ];
        let textnode = "";
        if (
          center[0] > southWest[0] &&
          center[0] < northEast[0] &&
          center[1] > southWest[1] &&
          center[1] < northEast[1]
        ) {
          if (item.finishedTime) {
            textnode =
              "," +
              "完成时间" +
              item.finishedTime +
              "," +
              "完成人员" +
              item.finishedPerson;
          }
          let text1 = new AMap.Text({
            // 文本
            vid: item.Bounds_id,
            position: center,
            text: item.Bounds_id + textnode
          });
          text1.on("click", events.click);
          text1.on("rightclick", events.rightclick);
          text1.on("oncontextmenu", event => {
            event.preventDefault();
          });
          allText.push(text1);
          text1.setMap(currentMap);
        }
      }
      this.allText = allText;
    },

    deleteText(currentMap) {
      currentMap.remove(this.allText);
      this.allText = [];
    },
    setFinishedMOde() {
      let id = this.id;
      this.$axios
        .get(this.$url_prefix + "geo/setBoundsStatus", {
          params: {
            id
          }
        })
        .then(res => {
          let id = res.data.id;
          let index = 0;
          for (var i = 0; i < this.bounds.length; i++) {
            if (this.bounds[i].Bounds_id == id) {
              index = i;
              this.bounds[index].status = 2;
              this.ifShowSpace = false;
              break;
            }
          }
        });
    },
    cancelFinishedMOde() {
      let id = this.id;
      this.$axios
        .get(this.$url_prefix + "geo/changeFinished", {
          params: {
            id
          }
        })
        .then(res => {
          let id = res.data.id;
          let index = 0;
          for (var i = 0; i < this.bounds.length; i++) {
            if (this.bounds[i].Bounds_id == id) {
              index = i;
              this.bounds[index].status = 1;
              this.ifShowSpace = false;
              break;
            }
          }
        });
    },
    cale() {
      return false;
    },
    setInformation() {
      let param = this.information;
      this.$axios
        .post(this.$url_prefix + "geo/setList", param)
        .then(res => {
          let currentMap = this.amapManager.getMap();
          currentMap.remove(this.oneText);
          this.ifsetServer = false;
          this.information = res.data.newItem;
          let poi = this.poi;
          poi.push(this.information);
          this.poi = [];
          this.$nextTick(() => {
            this.poi = poi;
          });
        })
        .catch(res => {
          this.$message("已上传数据，无需在上传");
          console.log(res);
          this.ifsetServer = false;
        });
    },
    onSearchResult(pois) {
      // 地图搜索
      if (pois.length > 0) {
        let { lng, lat } = pois[0];
        this.center = [lng, lat];
      }
      let param = {
        name: pois[0].name,
        cityname: "上海市",
        typecode: pois[0].type,
        type: pois[0].type,
        id: pois[0].id,
        location: [pois[0].location.lng, pois[0].location.lat],
        owntype: ""
      };
      this.information = param;
      // this.ifsetServer = true;
      let id = param.id;
      this.$axios
        .get(this.$url_prefix + "geo/one", {
          params: {
            id
          }
        })
        .then(res => {
          if (!res.data.data) {
            this.ifsetServer = true;
            let currentMap = this.amapManager.getMap();
            currentMap.remove(this.oneText);
            let text1 = new AMap.Text({
              // 文本
              vid: this.information.id,
              position: this.information.coordinates,
              text: this.information.name + this.information.owntype
            });
            text1.on("click", this.markerevent1.click);
            text1.on("init", this.markerevent1.init);
            this.oneText.push(text1);
            text1.setMap(currentMap);
          } else {
            this.ifsetServer = false;
            this.information = res.data.data;
            let currentMap = this.amapManager.getMap();
            currentMap.remove(this.oneText);
            let poi = this.poi;
            let two = [];
            let sty = {
              color: "#fff00",
              "text-decoration": "line-through",
              "font-size": "12px"
            };
            for (var item of poi) {
              two.push(item.name);
            }
            if (two.indexOf(this.information.name) == -1) {
              let text1 = new AMap.Text({
                // 文本
                vid: res.data.data.id,
                position: res.data.data.coordinates,
                text: res.data.data.name + res.data.data.owntype,
                style: res.data.data.status == 2 ? sty : {}
              });
              text1.on("click", this.markerevent1.click);
              text1.on("init", this.markerevent1.init);
              this.oneText.push(text1);
              text1.setMap(currentMap);
            }
          }
        })
        .catch(() => {});
    },
    setPopxy(pop) {
      this.popxy = pop;
      this.ifdeletekind = true;
      this.dialogVisible = false;
    },
    ifdelete() {
      this.ifdeletekind = false;
      if (this.popxy == "deleteKind") {
        this.deleteKind();
        this.popxy = "";
      }
      if (this.popxy == "cancelKind") {
        this.cancelKind();
        this.popxy = "";
      }
    },
    changeKind() {
      let target = this.poideletetarget;
      let poi = this.poi;
      poi[this.code].state = 0;
      this.poi = [];
      this.$nextTick(() => {
        this.poi = poi;
      });
      console.log(target);
      this.poiss = [];
      let poiss = [];
      for(var i=0;i<this.poisscopy.length;i++){
              if(i==this.codecopy){continue}
              poiss.push(this.poisscopy[i])
            }
      this.$nextTick(() => {
        this.poiss = poiss;
      });
      this.$axios
        .get(this.$url_prefix + "geo/change/boundary", {
          params: {
            id: target.id
          }
        })
        .then(() => {
          this.dialogVisible = false;
        });
    },
    startEditor() {
      let currentMap = this.amapManager.getMap();
      let path = this.path;
      let id = this.poideletetarget.id;
      if (this.poideletetarget.boundary) {
        path = this.setboundary();
      }
      if (this.ifpolygon == 0) {
        var polygon = new AMap.Polyline({
          vid: id,
          zIndex: 500,
          path: path,
          borderWeight: 1, // 线条宽度，默认为 1
          strokeColor: "black" // 线条颜色
        });
        this.polygon = polygon;
        polygon.setMap(currentMap);
        this.ifpolygon = 1;
      } else {
        this.polygon.setOptions({
          path: this.setboundary()
        });
      }
    },
    setPolygon() {
      let path = this.polygon.getPath();
      let currentMap = amapManager.getMap();
      let x = 0;
      let poideletetarget = this.poideletetarget;
      poideletetarget.boundary = path;
      let poiss = this.poiss
      let poisscopy = this.poisscopy
      poiss.push(poideletetarget)
      poisscopy.push(poideletetarget)
      this.poiss = []
      this.$nextTick(()=>{
        this.poiss=poiss
        this.poisscopy=poisscopy

      })
      this.$axios
        .post(this.$url_prefix + "geo/change/boundary", {
          params: {
            id: this.poideletetarget.id,
            path
          }
        })
        .then(res => {
          this.ifxyxy = false;
          currentMap.remove(this.pathmarker);
          currentMap.remove(this.polygon);
          this.$message({
            type: "success",
            message: "已经成功上传"
          });
        })
        .catch(res => {
          this.$message.error("上传失败");
        });
    },
    setboundary() {
      let result;
      let results = [];
      if (this.ifpolygon == 0) {
        result = this.poideletetarget.boundary.slice();
      } else {
        result = this.path.slice();
      }
      if (result.length > 3) {
        result.push(result[0]);
      }
      for (let item of result) {
        if (item.lng) {
          let xxx = [item.lng, item.lat];
          results.push(xxx);
          console.log(xxx, 454566);
        } else {
          results.push(item);
        }
      }
      console.log(results);
      return result;
    },
    uuid() {
      var s = [];
      // 随机的id值从以下字符串中产生
      var uuidData = "0123456789abcdefghijklmnopqrstuvwxyz";
      var uuidDataLength = uuidData.length;
      //此处循环了36次，可以修改循环次数，循环次数决定生成id长度
      for (var i = 0; i < 36; i++) {
        // 从uuidData中随机截取一个字符
        s[i] = uuidData.substr(Math.floor(Math.random() * uuidDataLength), 1);
      }
      var uuid = s.join("");
      return uuid;
    },
    setdist() {
      this.$axios.get(this.$url_prefix + "hdhdhhdh").then(res => {
        console.log(res);
      });
      // let that = this;
      // new AMap.DistrictSearch({
      //   subdistrict: 0, //返回下一级行政区
      //   extensions: "all", //返回行政区边界坐标组等具体信息
      //   level: "province" //查询行政级别为 市
      // }).search("中国", function(status, result) {
      //   new AMap.DistrictSearch({
      //     subdistrict: 0, //返回下一级行政区
      //     extensions: "all", //返回行政区边界坐标组等具体信息
      //     level: "district" //查询行政级别为 市
      //   }).search(filejson[8].name, (status, result) => {
      //     // console.log(result)
      //     let arr=[]
      //       for(let j of result.districtList[0].boundaries[0]){
      //         // console.log(j)
      //           arr.push([j.lng,j.lat])
      //       }
      //     let param = {
      //       bounds:filejson[8].dis , //各区区域的范围
      //       quyu: filejson[8].name
      //     };
      //     console.log(arr)
      //     for(let item of arr){
      //       console.log(item)

      //     }
      //     that.district = filejson[8].dis
      //     console.log(that.district)
      //     console.log(param);
      //     that.$axios
      //       .post(that.$url_prefix + "geo/setBounds", param)
      //       .then(res => {
      //         console.log(res);
      //       });
      //   });
      // });
      // console.log(filejson[0].districts);
    },
    changedistrictList() {
      let para = {
        city: this.amapName,
        district: this.districtSelect
      };
      this.$axios.post(this.$url_prefix + "geo/getBounds", para).then(res => {
        console.log(res);
        this.bounds = res.data.rectangleList;
      });
    },
    getBoundary() {
      let that = this;
      console.log(that.amapCenterName);
      if (that.amapCenterName) {
        new AMap.DistrictSearch({
          subdistrict: 0, //返回下一级行政区
          extensions: "all", //返回行政区边界坐标组等具体信息
          level: "province" //查询行政级别为 市
        }).search("中国", function(status, result) {
          new AMap.DistrictSearch({
            subdistrict: 0, //返回下一级行政区
            extensions: "all", //返回行政区边界坐标组等具体信息
            level: "district" //查询行政级别为 市
          }).search(that.amapCenterName, (status, result) => {
            console.log(result);
            if (result.districtList.length > 0) {
              let center = result.districtList[0].center;
              let maxLength = result.districtList[0].boundaries.sort(
                (a, b) => b.length - a.length
              );
              let district = maxLength[0].map(item => [item.lng, item.lat]);
              that.cityDistrict = district;
              center = [center.lng, center.lat];
              that.center = center;
              let x = center[0] + 0.105 * 0.1;
              let y = center[1] + 0.09 * 0.1;
              let xy = [x, y];
              let x1 = center[0] - 0.105 * 0.1;
              let y1 = center[1] - 0.09 * 0.1;
              let xy1 = [x1, y1];
              let xxyy = [xy, xy1];
              let bound = xxyy;
              let bounds_copy = [];
              for (var i = -50; i < 50; i++) {
                for (var j = -50; j < 50; j++) {
                  let x = bound[0][0] + 0.105 * 0.2 * j;
                  let y = bound[0][1] + 0.09 * 0.2 * i;
                  let xy = [x, y];
                  let x1 = bound[1][0] + 0.105 * 0.2 * j;
                  let y1 = bound[1][1] + 0.09 * 0.2 * i;
                  let xxyy = [x1, y1];
                  let boundss = [xy, xxyy];
                  let box_center = [
                    boundss[0][0] - 0.105 * 0.1,
                    boundss[0][1] - 0.09 * 0.1
                  ];
                  let res = AMap.GeometryUtil.isPointInRing(
                    box_center,
                    district
                  );
                  if (res) {
                    bounds_copy.push(boundss);
                  }
                }
              }
              that.bounds_copy = bounds_copy;
              that.bounds_copy_copy = bounds_copy;
              console.log(that.bounds_copy);
            } else {
              that.$message("请输入正确的城市地址");
            }
          });
        });
      } else {
        that.$message("请输入城市地址");
      }
    },
    getArea() {
      let that = this;
      if(!that.cityName){
        this.$message('请输入城市')
        return
      }
      new AMap.DistrictSearch({
        subdistrict: 1, //返回下一级行政区，0不返回1返回
        extensions: "all", //返回行政区边界坐标组等具体信息
        level: "province" //查询行政级别为 市
      }).search(that.cityName, function(status, result) {
        console.log(result);
        let district = result.districtList.sort(
          (a, b) => b.districtList.length - a.districtList.length
        );
        let center = result.districtList[0].center;
        center = [center.lng, center.lat];
        that.center = center;
        district = district[0].districtList;
        that.searchDistrictList = district.map(item => {
          return {
            value: item.name,
            label: item.name
          };
        });
      });
    },
    getLine() {
      let that = this;
      let currentMap = that.amapManager.getMap();
      if (that.disPolygon) currentMap.remove(that.disPolygon);
      console.log(that.searchDistrictSelect);
      new AMap.DistrictSearch({
        subdistrict: 0, //返回下一级行政区
        extensions: "all", //返回行政区边界坐标组等具体信息
        level: "district" //查询行政级别为 市
      }).search(that.searchDistrictSelect, (status, result) => {
        let maxLength = result.districtList[0].boundaries.sort(
          (a, b) => b.length - a.length
        );
        let district = maxLength[0].map(item => [item.lng, item.lat]);
        let polygon = new AMap.Polyline({
          vid: that.searchDistrictSelect,
          zIndex: 500,
          path: district,
          borderWeight: 1, // 线条宽度，默认为 1
          strokeColor: "black" // 线条颜色
        });
        that.disPolygon = polygon;
        polygon.setMap(currentMap);
        let bounds_copy = that.bounds_copy_copy;
        let bounds = []
        bounds_copy.forEach(item => {
          let box_center = [item[0][0] - 0.105 * 0.1, item[0][1] - 0.09 * 0.1];
          let res = AMap.GeometryUtil.isPointInRing(box_center, district);
          if(res)bounds.push(item)
        });
        that.bounds_copy = bounds
        console.log(result,maxLength,district, "result");
      });
    },
    setLine() {
      let that = this
      if(!that.searchDistrictSelect){
        that.$message('请选择区域')
        return
      }
      if(!that.bounds_copy_copy.length){
        that.$message('请先获取所有格子数据')
        return
      }
      that.$axios.post(this.$url_prefix + "geo/setBounds",{
        bounds:that.bounds_copy,
        city:that.cityName,
        district:that.searchDistrictSelect
      }).then((res)=>{
        console.log(res)
        if(!res.data.success)that.$message('已有该城市地区块')
        else that.$message('上传成功')
      })
    },
    searchCity(){
      let that = this;
      if(!that.amapName){
        this.$message('请输入城市')
        return
      }
      that.searchOption.city = that.amapName
      new AMap.DistrictSearch({
        subdistrict: 1, //返回下一级行政区，0不返回1返回
        extensions: "all", //返回行政区边界坐标组等具体信息
        level: "province" //查询行政级别为 市
      }).search(that.amapName, function(status, result) {
        // 可能出现多个值，是因为可能多个城市有同样的区
        let district = result.districtList.sort(
          (a, b) => b.districtList.length - a.districtList.length
        );
        let center = result.districtList[0].center;
        center = [center.lng, center.lat];
        that.center = center;
        district = district[0].districtList;
        let districtSelect = district.map(item => {
          return {
            value: item.name,
            label: item.name
          };
        });
        districtSelect.unshift({
          value: "all",
          label: "所有"
        },)
        that.districtList = districtSelect
        that.getnumber();
      }); 
    }
  }
};
</script>

<style scoped>
.nihao {
  background-color: #fff;
}
.amapDemo {
  position: relative;
}
.search-box {
  position: absolute;
  left: 0;
  top: 0;
}
#editor {
  position: absolute;
  display: flex;
  top: 0;
  left: 400px;
  background-color: #fff;
}
#editor button {
  margin: 0 50px;
}
#boundaryEditor {
  position: absolute;
  bottom: 10px;
  left: 400px;
  background-color: #fff;
}
#boundaryEditor button {
  margin: 0 50px;
}
</style>



// WEBPACK FOOTER //
// src/page/poiInformation.vue